import styles from './Resources.module.css';

export const TrabajosPracticos: React.FC = () => {
  const trabajosPracticos = [
    {
      id: 1,
      titulo: 'TP N°1: Análisis de Variabilidad Genética',
      objetivos: [
        'Identificar y cuantificar variabilidad fenotípica en poblaciones vegetales',
        'Calcular estadísticos descriptivos (media, varianza, desviación estándar)',
        'Construir histogramas y analizar patrones de distribución',
        'Diferenciar entre caracteres cualitativos y cuantitativos',
      ],
      metodologia:
        'Evaluación de poblaciones de maíz mediante caracteres cuantitativos (altura de planta, longitud de espiga, número de hileras) y cualitativos (color de grano, textura de endospermo). Los estudiantes medirán 50-100 plantas individuales, calcularán estadísticos descriptivos y construirán histogramas de distribución fenotípica.',
      duracion: '2 clases (4 horas)',
      modalidad: 'Campo y Laboratorio',
      materiales: 'Cintas métricas, calibres, planillas de registro, software estadístico (R/Excel)',
    },
    {
      id: 2,
      titulo: 'TP N°2: Estimación de Heredabilidad',
      objetivos: [
        'Diseñar ensayos de progenies para estimar componentes de varianza',
        'Calcular heredabilidad en sentido amplio (H²) y estricto (h²)',
        'Interpretar valores de heredabilidad para decisiones de mejoramiento',
        'Predecir respuesta a selección usando ecuación del mejorador',
      ],
      metodologia:
        'Análisis de datos de ensayos de progenies S1 o medios hermanos en maíz. Los estudiantes realizarán ANOVA para particionar varianzas, calcularán h² y H², e interpretarán los resultados para recomendar estrategias de selección apropiadas.',
      duracion: '1 clase (2 horas)',
      modalidad: 'Laboratorio',
      materiales: 'Software R/RStudio, Excel, dataset provisto de ensayos multiambientales FCA-UNC',
    },
    {
      id: 3,
      titulo: 'TP N°3: Métodos de Selección en Autógamas',
      objetivos: [
        'Aplicar método genealógico (pedigrí) en poblaciones segregantes',
        'Comparar eficiencia de método bulk vs. pedigrí',
        'Manejar registros de pedigrí y nomenclatura de líneas',
        'Realizar selección individual y evaluación de progenies',
      ],
      metodologia:
        'Simulación de método genealógico y bulk en trigo. Selección individual en F2 basada en caracteres visibles (altura, vigor, resistencia a roya), identificación de plantas seleccionadas, evaluación de progenies F3-F5 en surcos, manejo de registros de pedigrí y nomenclatura de líneas.',
      duracion: '2 clases (4 horas)',
      modalidad: 'Campo - Estación Experimental',
      materiales: 'Plantas de trigo en diferentes generaciones, etiquetas, registros de pedigrí',
    },
    {
      id: 4,
      titulo: 'TP N°4: Evaluación de Interacción Genotipo × Ambiente',
      objetivos: [
        'Analizar datos de ensayos multiambientales (MET)',
        'Identificar genotipos estables vs. específicamente adaptados',
        'Interpretar gráficos de interacción G×E',
        'Aplicar métodos de evaluación de estabilidad fenotípica',
      ],
      metodologia:
        'Análisis de bases de datos reales de ensayos multiambientales de maíz híbridos en diferentes localidades y años. Uso de biplot, regresión sobre ambiental media, y análisis de varianza para detectar patrones de interacción.',
      duracion: '2 clases (4 horas)',
      modalidad: 'Laboratorio - Informática',
      materiales: 'Software R, GGE Biplot (versión trial), datos reales de INTA/universidades',
    },
  ];

  return (
    <div className={styles.resourcesPage}>
      <div className={styles.header}>
        <h2>🔬 Trabajos Prácticos y Actividades</h2>
        <p className={styles.subtitle}>
          Material práctico para complementar el aprendizaje teórico de la materia. Cada TP incluye
          objetivos, metodología, duración estimada y recursos necesarios.
        </p>
      </div>

      <div className={styles.resourcesList}>
        {trabajosPracticos.map((tp) => (
          <div key={tp.id} className={styles.resourceItem}>
            <h3 className={styles.itemTitle}>{tp.titulo}</h3>

            <div className={styles.itemSection}>
              <h4 className={styles.sectionTitle}>Objetivos</h4>
              <ul className={styles.list}>
                {tp.objetivos.map((obj, idx) => (
                  <li key={idx}>{obj}</li>
                ))}
              </ul>
            </div>

            <div className={styles.itemSection}>
              <h4 className={styles.sectionTitle}>Metodología</h4>
              <p className={styles.text}>{tp.metodologia}</p>
            </div>

            <div className={styles.itemSection}>
              <div className={styles.infoRow}>
                <div className={styles.infoPair}>
                  <strong>Duración:</strong> {tp.duracion}
                </div>
                <div className={styles.infoPair}>
                  <strong>Modalidad:</strong> {tp.modalidad}
                </div>
              </div>
              <div className={styles.infoPair}>
                <strong>Materiales:</strong> {tp.materiales}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
